/**
 * Binar javobni PRINTERGA yuborish — `downloadBlob` ning egizagi.
 *
 * Nega faylni saqlamaymiz: skladchining ishi "PDF ni yuklab ol, Yuklanganlar
 * papkasini och, ochib ko'r, Ctrl+P bos" emas. U javon oldida turadi va unga
 * etiketka kerak. Shuning uchun PDF ko'rinmas `iframe` ga qo'yilib,
 * brauzerning o'z bosma oynasi chaqiriladi — printer tanlanadi, tamom.
 *
 * `blob:` manzili ataylab: server javobida `Content-Disposition: attachment`
 * turadi va to'g'ridan-to'g'ri ochilsa brauzer uni ko'rsatmay, saqlab
 * qo'yardi. Bizda javob `apiBlob` orqali kelib, brauzerda o'zimiz yasagan
 * manzilga aylanadi — sarlavha ta'sir qilmaydi va `Authorization` ham
 * manzilga yozilmaydi.
 */

/** Bir vaqtda bitta bosma ramkasi turadi — oldingisi almashtiriladi. */
const FRAME_ID = 'eombor-print-frame';

interface OpenPrint {
  frame: HTMLIFrameElement;
  url: string;
}

const previous: { current: OpenPrint | null } = { current: null };

/**
 * Ramka DARHOL o'chirilmaydi: bosma oynasi ochiq turganda uni olib tashlash
 * ba'zi brauzerlarda bosmani bekor qiladi. Shuning uchun tozalash keyingi
 * bosmaga qoldiriladi — ekranda ko'rinmaydigan 0×0 element hech kimga
 * xalaqit bermaydi.
 */
const dropPrevious = (): void => {
  const open = previous.current;
  if (open === null) return;
  open.frame.remove();
  URL.revokeObjectURL(open.url);
  previous.current = null;
};

export const printBlob = (blob: Blob): void => {
  dropPrevious();

  const url = URL.createObjectURL(blob);
  const frame = document.createElement('iframe');
  frame.id = FRAME_ID;
  frame.setAttribute('aria-hidden', 'true');
  frame.title = 'print';
  // `display: none` EMAS: yashirilgan ramkaning hujjati ba'zi brauzerlarda
  // umuman yuklanmaydi va bosma ishlamaydi. O'lchamsiz ramka esa ko'rinmaydi.
  frame.style.cssText = 'position:fixed;right:0;bottom:0;width:0;height:0;border:0;';

  frame.addEventListener('load', () => {
    try {
      const view = frame.contentWindow;
      if (view === null) throw new Error('print frame yo\'q');
      view.focus();
      view.print();
    } catch {
      // Brauzer ramkadan bosishga ruxsat bermasa — hech bo'lmasa PDF ni
      // ko'rsatamiz, odam o'zi Ctrl+P qiladi. Jim qolish eng yomoni.
      window.open(url, '_blank', 'noopener');
    }
  });

  frame.src = url;
  document.body.appendChild(frame);
  previous.current = { frame, url };
};
